export enum DATE_PICKER {
  dateFormatToYear = 'yyyy/MM/dd',
  dateFormatFullYear = 'yyyy',
  dateFormatQuarter = 'yyyy, QQQ',
  placeholder = 'yyyy/mm/dd',
  dateFormatToPayload = 'yyyy-MM-dd',
  dateFormatMonth = 'MMM, yyyy',
  dateFormatFullMonth = 'MMMM',
  dateFormatHoliday = 'MMM dd, yyyy EEEE',
  dateFormatMonthAndDay = 'MMM dd, yyyy',
  dateFormatToStandard = 'dd/MM/yyyy',
}

export enum POINTER {
  pointer = 'pointer',
  default = 'default',
}

export const PER_PAGE_DATA = [50, 100, 250];

export const PAGES_NUMBER_LIMIT = 5;

export const CURRENCY = ['USD', 'UAH'];

export const MONTH_COUNT = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const RESOURCE_REQUEST_STATUSES = [
  'All',
  'Approved',
  'Draft',
  'Fin-check',
  'In Review',
  'Purchased',
  'Rejected',
  'Requested',
  'Waiting for confirmation',
];

export const CONTRACTS_STATUSES = [
  'All',
  'Draft',
  'Legal paperwork',
  'Waiting for sign',
  'Signed',
  'Active',
  'Closed',
];

export const CONTRACTS_STATUSES_EDIT = ['Draft', 'Legal paperwork', 'Waiting for sign', 'Signed', 'Active', 'Closed'];

export const BILLING_SOURCES = ['Team', 'External', 'Internal', 'None'];

export const SERVICE_TYPES = [
  '.NET',
  'Consulting',
  'Blockchain',
  'Android',
  'BA',
  'BI',
  'Customer Support',
  'Delivery',
  'Design',
  'DevOps',
  'Flutter',
  'iOS',
  'Java',
  'JS',
  'Markup',
  'Node.JS',
  'PHP',
  'PM',
  'PO',
  'QA',
  'QA Automation',
  'React Native',
  'Python',
  'Management',
  'Solution Architect',
  'Data Engineering',
];

export const SERVICES_CURRENCY = [
  {
    name: 'USD',
  },
  {
    name: 'EUR',
  },
  {
    name: 'GBP',
  },
];

export const QUANTITY = [0.25, 0.5, 0.75, 1];
